<template>
  <div class="boxes videos vert-padded">
    <div v-if="nextFollowupQuestion" class="box question-box" style="display: none;">
      <h1>{{t("Weekly Question")}}</h1>
      <h3>{{nextFollowupQuestion.question}}</h3>
      <div class="options flexy">
        <button v-for="(option, i) in nextFollowupQuestion.options" :key="i" @click="answerFollowupQuestion(nextFollowupQuestion.day, option)" class="btn btn-primary">{{option}}</button>
      </div>
    </div>
    <h1>{{t("Followup Plan")}}</h1>
    <div class="countdown">
      <div v-if="liveStreamTime > 0 && !moreThan10HoursToStream">
        <p>{{t("The next live stream will start in:")}}</p>
        <h2>{{liveStreamTimeHHMMSS}}</h2>
      </div>
      <div v-else-if="liveStreamTime > 0 && moreThan10HoursToStream">
        <p>{{t("The next live stream will start on:")}}</p>
        <h2>{{prettyStreamDate}}</h2>
      </div>
      <div v-else-if="liveStreamTime > -7200">
        <p>{{t("The live stream has started!")}}</p>
        <button class="btn btn-primary" @click="getLiveStreamUrl">{{t("Go to Stream")}}</button>
      </div>
      <div v-else>
        <p>{{t("The live stream has ended!")}}</p>
        <p>{{t("The next live stream will be posted here shortly.")}}</p>
      </div>
    </div>
    <div class="videos boxes" v-if="pastStreams.length">
      <h2>{{t("Past Live Streams")}}</h2>
      <Box>
        <div class="s" v-for="(stream) in pastStreams" :key="stream.date">
          <h3>{{stream.title}}</h3>
          <Vimeo :path="stream.path" />
        </div>
      </Box>
      <Box>
      <h1>{{t("About the follow-up plan")}}</h1>
      <Vimeo path="1022009497" />
      </Box>
    </div>
  </div>
</template>

<script>
import t from "@/lib/Locale";
import ArrowRightIcon from '@/assets/icons/arrow-right.svg';
import Fito from "@/lib/fito";
import Vimeo from "@/components/ui/widgets/Vimeo.vue";
import Box from "@/components/ui/widgets/Box.vue";

const followupPlanStart = new Date('2024-12-08 00:00:00');

export default {
  name: "FollowupFeed",
  components: {Box, Vimeo},
  data() {
    return {
      ArrowRightIcon,
      offsetHours: 0,
      liveStreamTime: null,
      liveStreamDate: null,
      pastStreams: [],
      weeklyQuestions: [],
      answeredWeeklyQuestions : []
    }
  },
  async mounted() {
    const login = await Fito().Login.CheckLogin();
    if (!login) await this.$router.push('/plan/login');
    this.setLiveCounter(login)
    this.populatePastStreams(login)

    this.liveStreamInterval = setInterval(this.updateLiveCounter, 1000)

    await this.getFollowupQuestions()

    if (login.meta && login.meta['followup-answers']) {
      for (let i = 0; i < login.meta['followup-answers'].length; i++) {
        this.answeredWeeklyQuestions.push(login.meta['followup-answers'][i].day * 1)
      }
    }

    console.log("Questions:", this.weeklyQuestions)
    console.log("Answered:", this.answeredWeeklyQuestions)
  },
  beforeDestroy() {
    clearInterval(this.liveStreamInterval)
  },
  computed : {
    liveStreamTimeHHMMSS() {
      let t = this.liveStreamTime
      let h = Math.floor(t/3600)
      let m = Math.floor((t - h*3600)/60); if (m < 10) m = '0' + m;
      let s = Math.floor(t - h*3600 - m*60); if (s < 10) s = '0' + s;
      return `${h}:${m}:${s}`
    },
    moreThan10HoursToStream() {
      return this.liveStreamTime > 36000
    },
    prettyStreamDate() {
      let d = this.liveStreamDate,
      dmy = d.split(' ')[0].split('-').reverse().join('/'),
          hm = d.split(' ')[1].split(':').slice(0,2).join(':')

      return `${dmy} ${hm}`
    },
    nextFollowupQuestion() {
      for (let i = 0; i < this.weeklyQuestions.length; i++) {
        if (!this.answeredWeeklyQuestions.includes(this.weeklyQuestions[i].day)) {
          return this.weeklyQuestions[i]
        }
      }
      return null
    }
  },
  methods: {
    t,
    async populatePastStreams(login) {
      const sheet = await Fito().loadPastStreams()
      const planStartDate = new Date(login['subscriber']['plan_start_date'])
      for (let i = 0; i < sheet.length; i++) {
        if (new Date(sheet[i].date) >= planStartDate) {
          this.pastStreams.push(sheet[i])
        }
      }

      // sort videos from last to first
      this.pastStreams.sort((a, b) => new Date(b.date) - new Date(a.date))
    },
    setLiveCounter(login) {
      this.liveStreamDate = login.settings['followup-live-date'];
      let t = new Date(), serverT = new Date(login.t), liveT = new Date(this.liveStreamDate || null)
      let timeDiff = t - serverT

      t.setTime(t.getTime() + timeDiff)

      this.liveStreamTime = Math.floor(liveT - t) / 1000
      this.offsetHours = Math.floor(timeDiff / 3600)
      console.log(liveT, this.liveStreamTime, this.offsetHours)
    },
    updateLiveCounter() {
      this.liveStreamTime--
      if (this.liveStreamTime <= 0) {
        clearInterval(this.liveStreamInterval)
      }
    },
    async getLiveStreamUrl() {
      const res = await Fito().Plan.getLiveCode()
      if (res.res === 'ok') {
        window.location.href = res.live_code
      }
    },

    followupPlanDay() {
      const totalDays = 64
      let d = new Date()
      let diff = d - followupPlanStart
      let day = Math.floor(diff / (1000 * 60 * 60 * 24))
      if (day < 0) day += totalDays
      return (day % totalDays)+1
    },

    followupPlanWeek() {
      return Math.floor(this.followupPlanDay() / 7)
    },

    // get weekly questions
    async getFollowupQuestions() {
      let res = await Fito().loadSheet('followup-quiz')
      res = res.map(it => {
        return {
          day: it[0]*1,
          week: it[1]*1,
          question: it[2],
          options: it[3].split(/\//g)
        }
      })
      this.weeklyQuestions = res.filter(it => it.week * 1 === this.followupPlanWeek())
    },

    async answerFollowupQuestion(day, answer) {
      this.answeredWeeklyQuestions.push(day)
      await Fito().RunAction('submit-followup-question-answer', {day, answer})
    }
  },

}
</script>